/* eslint-disable react/prop-types */
import React from 'react';
import { RichText } from '../../core/RichText';
import useSurveyStyles from './useStyles';

export type Props = {
  id?: Element['id'];
  text: string;
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
} & React.HTMLAttributes<HTMLHeadingElement>;

const PageTitle: React.FC<Props> = ({ id, element = 'h2', text, ...otherProps }) => {
  const { pageTitle } = useSurveyStyles();
  return (
    <RichText
      id={id}
      element={element}
      text={text}
      className={pageTitle}
      data-testid="PageTitle__Title"
      {...otherProps}
    />
  );
};

export default PageTitle;
